<template>
    <div id="app">
        <!-- <transition :name="transitionName" > -->
        <keep-alive :include="/_useKP$/">
            <router-view
                    class="child-view"
                    v-wechat-title="$route.meta.title"
            ></router-view>
        </keep-alive>
        <el-amap vid="amap" :plugin="plugin" class="amap-demo"></el-amap>
        <!-- </transition> -->
        <loading></loading>
        <loadSking></loadSking>
    </div>
</template>

<script>
import loading from "./components/loading/index.vue";
import loadSking from "./components/skeleton/index.vue";

export default {
    name: "App",
    components: {
        loading,
        loadSking,
    },
    created() {
        // if (sessionStorage.getItem("store")) {
        //     this.$store.replaceState(
        //         Object.assign(
        //             {},
        //             this.$store.state,
        //             JSON.parse(sessionStorage.getItem("store"))
        //         )
        //     );
        // }
        // var u = navigator.userAgent;
        // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        //
        // if (isAndroid) {
        //     window.addEventListener("beforeunload", () => {
        //         // sessionStorage.setItem(
        //         //     "store",
        //         //     JSON.stringify(this.$store.state)
        //         // );
        //     });
        // } else if (isiOS) {
        //
        //     let self = this;
        //     document.addEventListener("visibilitychange", function() {
        //         // 用户离开了当前页面
        //         if (document.visibilityState === "hidden") {
        //             sessionStorage.setItem(
        //                 "store",
        //                 JSON.stringify(self.$store.state)
        //             );
        //         }
        //
        //         // 用户打开或回到页面
        //         if (document.visibilityState === "visible") {
        //         }
        //     });
        // }
    },
    data() {
        let that = this;
        return {
            transitionName: "slide-left",
            isFirst: true,
            positions: {
                lng: "",
                lat: "",
                address: "",
                loaded: false,
            },
            plugin: [
                {
                    pName: "Geolocation",
                    events: {
                        // init(o) {
                        //     // o 是高德地图定位插件实例
                        //     o.getCurrentPosition(
                        //         (status, result) => {
                        //             // console.log("1",result.position.lat.toixed(6))
                        //             // console.log("1",result.position.lng.toixed(6))
                        //             // localStorage.setItem('lat',result.position.lat.toixed(6))
                        //             // localStorage.setItem('lng',result.position.lng.toixed(6))
                        //             if (result && result.position) {
                        //                 that.str = result.formattedAddress;
                        //                 if (!!result.addressComponent) {
                        //                     let province =
                        //                         result.addressComponent
                        //                             .province;
                        //                     let city =
                        //                         result.addressComponent.city ==
                        //                         ""
                        //                             ? result.addressComponent
                        //                                   .district
                        //                             : result.addressComponent
                        //                                   .city;
                        //                     let position = [province, city];
                        //                     sessionStorage.setItem(
                        //                         "position",
                        //                         JSON.stringify(position)
                        //                     );
                        //                 }
                        //             }
                        //         },
                        //         function() {
                        //             sessionStorage.setItem("position", "error");
                        //             console.log("定位失败");
                        //         }
                        //     );
                        // }
                    },
                },
            ],
        };
    },
    watch: {
        $route(to, from) {
            var that = this;
            if (that.isFirst) {
                let url = window.location.href.split("#")[0];
                that.isFirst = false;
                that.$store.commit("setShareUrl", url);
            }
        },
    },
    methods: {},
};
</script>

<style lang="scss">
@import "assets/scss/mint-ui.css";
@import "assets/scss/common.scss";
@import "assets/scss/class.scss";

body.modal-open {
    position: fixed;
    width: 100%;
}

.child-view {
    //   position: absolute;
    //   width: 100%;
    //   min-height: 100vh;
    //   // overflow: auto;
    //   -webkit-overflow-scrolling: touch;
    //   transition: all 0.8s cubic-bezier(0.55, 0, 0.1, 1);
    //   color: #333;
}

.dialog {
    position: fixed;
    height: 100%;
    width: 100%;
}

.slide-left-enter,
.slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(50px, 0);
    transform: translate(50px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-50px, 0);
    transform: translate(-50px, 0);
}

.weui-toast {
    width: 3rem !important;
    height: 3rem !important;

    .weui-loading {
        width: 0.8rem !important;
        height: 0.8rem !important;
    }
}

.pswp__button {
    transform: scale(2);
    margin: 0.2rem;
}
.check-agree {
    .van-checkbox__icon {
        background: #dddddd;
        border-radius: 8px;
    }
    .van-checkbox__icon .van-icon {
        border: 0 !important;
        border-radius: 8px;
    }
    .van-checkbox__label {
        color: #999999 !important;
        margin-left: 16px;
    }
    .van-checkbox__icon--disabled .van-icon{
        background: #355D4B !important;
    }
    .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{
        color: #fff !important;
    }
}
.submit-checkout{
    .van-checkbox__icon .van-icon{
        border: 1px solid #666666 !important;
    }
    .van-checkbox__icon--checked .van-icon{
        color: #666666 !important;
        border: 1px solid #666666 !important;
    }
    .van-checkbox__label{
        margin-left: 16px;
    }
}
.uploading-btn {
    width: 160px;
    height: 160px;
    background: #f5f7f6;
    border-radius: 24px;
}
.van-uploader__preview-image {
    width: 160px;
    height: 160px;
}
.van-uploader__preview {
    margin: 0 32px 32px 0;
    border-radius: 24px;
    overflow: hidden;
}
// .van-swipe__indicators {
//   bottom: 150px !important;
// }
.text-voice-evaluate-content .text{
    background: #ffffff;
}

.toast-max{
    font-size: 36px;
}

.toast-max2{
    font-size: 32px;
}
.no-resize {
    resize: none!important;
}
</style>
